import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {Button, ColumnLayout, Form, FormSection} from '@amzn/awsui-components-react/';
import {reduxForm} from 'redux-form';

import {validateForm} from './validation';

import PolarisInputField from 'views/components/Form/PolarisInputField';

import fetchPlan from 'actions/plan';
import dispatchSubmitForm, {redirectHome} from 'constants/functions';
import {PARTNER_OPPORTUNITIES} from 'constants/forms';
import {wholeNumberValidation} from "constants/forms/validation";
import {FeedbackHeader} from "views/components/FeedbackHeader";

const FORM_NAME = PARTNER_OPPORTUNITIES;

class PartnerOpportunities extends Component {
  componentDidMount() {
    this.props.fetchPlan(this.props.match.params.planId);
  }

  render() {
    const {handleSubmit, dispatch, planId, formName, history, year} = this.props;
    return (
      <div>
        <div>
          {FeedbackHeader(history)}
        </div>

        <Form
          onSubmit={handleSubmit}
          actions={
            <div>
              <Button text="Cancel" variant="link" onClick={() => redirectHome(history, planId)}/>
              <Button
                onClick={handleSubmit(values => {
                  dispatchSubmitForm(
                    {
                      values,
                      form: FORM_NAME,
                      completed: false,
                      planId,
                      formName
                    },
                    dispatch
                  );
                })}
                text="Save as Draft"
                variant="primary"
              />
              <Button
                onClick={handleSubmit(values => {
                  dispatchSubmitForm(
                    {
                      values,
                      form: FORM_NAME,
                      completed: true,
                      planId,
                      formName
                    },
                    dispatch
                  );
                  this.props.history.push('/plans/' + planId);
                })}
                text="Submit"
                variant="primary"
              />
            </div>
          }
        >
          <FormSection header="Partner Opportunities">
            <ColumnLayout columns={2}>
              <div data-awsui-column-layout-root="true">
                <PolarisInputField
                  label="Number of Qualified Opportunities Submitted"
                  description={`${year}`}
                  name={`opportunitiesCount${year}`}
                  required
                  autofocus
                  placeholder="#"
                  validate={[wholeNumberValidation]}
                />
                <PolarisInputField
                  label="Number of Customer Wins (Launch Opportunities)"
                  description={`${year}`}
                  name={`customerWinsCount${year}`}
                  required
                  autofocus
                  placeholder="#"
                  validate={[wholeNumberValidation]}
                />
                <PolarisInputField
                  description={`${year - 1}`}
                  name={`opportunitiesCount${year - 1}`}
                  required
                  autofocus
                  placeholder="#"
                  validate={[wholeNumberValidation]}
                />
                <PolarisInputField
                  description={`${year - 1}`}
                  name={`customerWinsCount${year - 1}`}
                  required
                  autofocus
                  placeholder="#"
                  validate={[wholeNumberValidation]}
                />
                <PolarisInputField
                  description={`${year - 2}`}
                  name={`opportunitiesCount${year - 2}`}
                  required
                  autofocus
                  placeholder="#"
                  validate={[wholeNumberValidation]}
                />
                <PolarisInputField
                  description={`${year - 2}`}
                  name={`customerWinsCount${year - 2}`}
                  required
                  autofocus
                  placeholder="#"
                  validate={[wholeNumberValidation]}
                />
              </div>
            </ColumnLayout>
          </FormSection>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    planId: state.plan.plan.id,
    year: state.plan.plan.year,
    formName: FORM_NAME,
    initialValues: {
      ...state.plan.plan.forms[FORM_NAME]
    }
  };
};

const mapDispatchToProps = dispatch => {
  //TODO: Remove/change this
  return {
    fetchPlan: planId => dispatch(fetchPlan(planId)),
    dispatch
  };
};

const formDecoratedComponent = reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
  validate: validateForm
})(PartnerOpportunities);
const connectDecoratedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(formDecoratedComponent);

export default withRouter(connectDecoratedComponent);
